export const SectionHeader = ({ index, overline, title, description }) => (
  <div className="mb-16 max-w-3xl">
    <div className="mb-4 flex items-center gap-4">
      {index && <span className="font-mono text-xs text-gold">{index}</span>}
      <span className="overline">{overline}</span>
    </div>
    <h2 className="font-display font-light tracking-tight text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
      {title}
    </h2>
    {description && (
      <p className="mt-6 max-w-2xl font-sans text-base md:text-lg font-light leading-relaxed text-slate-400">
        {description}
      </p>
    )}
  </div>
);
